module.exports = __webpack_public_path__ + "static/media/PlndrLogo.dc3145bd.png";